import { useEffect, useState } from 'react'
import Widget from './Widget'
import styles from './WidgetClock.module.css'

export default function WidgetClock() {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000)
    return () => clearInterval(interval)
  }, [])

  const seconds = time.getSeconds()
  const minutes = time.getMinutes()
  const hours = time.getHours()

  const secondDeg = seconds * 6
  const minuteDeg = minutes * 6 + seconds * 0.1
  const hourDeg = (hours % 12) * 30 + minutes * 0.5

  return (
    <Widget size="small">
      <div className={styles.clock}>
        <div className={styles.face}>
          <div className={`${styles.hand} ${styles.hour}`} style={{ transform: `rotate(${hourDeg}deg)` }} />
          <div className={`${styles.hand} ${styles.minute}`} style={{ transform: `rotate(${minuteDeg}deg)` }} />
          <div className={`${styles.hand} ${styles.second}`} style={{ transform: `rotate(${secondDeg}deg)` }} />
          {[...Array(12)].map((_, i) => (
            <div key={i} className={styles.number} style={{ transform: `rotate(${i * 30}deg)` }}>
              <span style={{ transform: `rotate(-${i * 30}deg)` }}>{i === 0 ? 12 : i}</span>
            </div>
          ))}
        </div>
      </div>
    </Widget>
  )
}
